import React from 'react';
import './App.css';
import Layout from './layouts/Layout';
import AnonyLayout from './layouts/AnonyLayout';
import { menus, anonyMenus } from './layouts/menus';
import { useDispatch, useSelector } from "react-redux";
import { LOGIN, LOGOUT } from "./services/actions";
import { useNavigate } from "react-router-dom";
import axios from 'axios';


function App() {
  let dispatch = useDispatch()
  const navigate = useNavigate()
  let auth = useSelector((state) => state?.loginState?.auth)
  React.useEffect(() => {
    dispatch({ type: `${LOGIN}_AUTH`, payload: null, local: true });
  }, [])

  React.useEffect(() => {
    //console.log("AUTH", JSON.stringify(auth))
    if (!auth) { onLogout() }
  }, [localStorage.getItem("auth")])
  const onLogout = () => {
    dispatch({ type: `${LOGOUT}_AUTH`, payload: null });
    navigate("/")
  }

  // React.useEffect(() => {
  //   let user = JSON.parse(localStorage.getItem("auth") || '{}')
  //   console.log("USer is here", user)
  //   if (user == null) {
  //     console.log("Always empty")
  //     navigate("/login/")
  //   } else {
  //     navigate("/")
  //   }
  // }, [auth?.token, navigate, axios.defaults.headers.common['Authorization']])
  return (<>
    {auth?.token && <Layout menus={menus}
      onLogout={() => { onLogout() }}
      appName={<label style={{ fontWeight: 800 }} className="text-center">{"BGLIVE"}</label>}
      ispushsidebar={true}
    />}
    {!auth?.token && <AnonyLayout menus={anonyMenus} />}

  </>
  );
}

export default App;
